import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { PetSpeciesFilterableType } from 'src/app/interfaces/pet';
import { ProductType, User } from 'src/app/interfaces/user';
import { PlanFeatureService } from 'src/app/services/common/plan-feature.service';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { UserService } from 'src/app/services/user/user.service';

export enum PricingTableSubTypes {
  IDENTIBASEPLUS = 'IDENTIBASEPLUS',
  IDENTIALERT = 'IDENTIALERT',
  IDENTIFIND = 'IDENTIFIND',
}

@Component({
  selector: 'app-fixed-pricing-table',
  templateUrl: './fixed-pricing-table.component.html',
  styleUrl: './fixed-pricing-table.component.scss'
})

export class FixedPricingTableComponent implements OnInit, OnChanges{
  @Input() disabled: boolean;
  @Input() pricingPlans: any;
  @Input() viewOnly: boolean;
  @Input() public user: User;
  @Input() buttonLabel: string;
  @Input() hidePrices: boolean;
  @Input() showShortDescription: boolean;
  @Input() showInfoLine: boolean;
  @Input() showFeatures: boolean;
  @Input() showPromo: boolean;
  @Input() petName: string;
  @Input() showWideIdentiAlertCard: boolean;
  @Input() hideIcons: boolean;
  @Input() hasBuyNow: boolean;
  @Input() appPriceCardFeatureText: string[];
  @Input() appAlertPriceCardFeatureText: string[];
  @Input() showPeachBanner: boolean;

  @Output() onClosePromo = new EventEmitter<string>();

  @Output() onSelect: EventEmitter<string> = new EventEmitter();
  @Output() onNavigateToProductPage: EventEmitter<string> = new EventEmitter();

  public doesTheUserHaveCat: boolean = false;
  public doesTheUserHaveDog: boolean = false;
  public identiFindSelected = 'identiFindSelected';
  public productType = ProductType;
  public planIdIdentiAlert: string;
  public PricingTableSubTypes = PricingTableSubTypes;
  public promoPopupOpen: boolean = false;
  public doesTheUserHaveOnlyCat: boolean = false;
  public identibasePlusAvailable: boolean = true;
  public identiAlertAvailable: boolean = true;
  public identiFindAvailable: boolean = true;
  public mainPlanContent = [];
  public isBrowser: boolean;
  closePromoPopup() {
    this.promoPopupOpen = false;
    this.onClosePromo.emit();
  }

  constructor(
    public userService: UserService,
    public membershipOptionsService: MemberShipOptionsService,
    public planFeatureService: PlanFeatureService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showPromo) {
      this.showPromo = changes.showPromo.currentValue;
      this.promoPopupOpen = this.showPromo;
    }
  }

  getFeaturesFor(plan: string): any[] {
    return this.planFeatureService.getFeaturesFor(plan);
  }

  getMainPlanCardContent(petName?: string) {
    return this.planFeatureService.getMainPlanContent(petName);
  }

  select(planId?: string): void {
    if (planId == this.identiFindSelected) {
      if (this.doesTheUserHaveCat && !this.doesTheUserHaveDog) {
        this.onSelect.emit(this.pricingPlans['identiAlertFindCat']);
      } else {
        this.onSelect.emit(this.pricingPlans['identiAlertFind']);
      }
    } else {
      this.onSelect.emit(planId);
    }
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  ngOnInit(): void {
    if (!this.viewOnly) {
      this.planIdIdentiAlert = this.pricingPlans.identiAlertAnnual;
    }
    this.mainPlanContent = this.getMainPlanCardContent(this.petName);
    if (this.user) {
      this.doesTheUserHaveCat = !!this.user.pets.find(
        (pet) => pet.speciesFilter === PetSpeciesFilterableType.Cat
      );
      this.doesTheUserHaveDog = !!this.user.pets.find(
        (pet) => pet.speciesFilter === PetSpeciesFilterableType.Dog
      );

      if (this.doesTheUserHaveCat && !this.doesTheUserHaveDog) {
        this.doesTheUserHaveOnlyCat = true;
      }
      this.identibasePlusAvailable = this.membershipOptionsService.identiBasePlusAvailable(
        this.user
      );
      this.identiAlertAvailable = this.membershipOptionsService.identiAlertAvailable(this.user);
      this.identiFindAvailable = this.membershipOptionsService.identiFindAvailable(this.user);
    }
    this.mainPlanContent = this.getMainPlanCardContent(this.petName);
  }

  public doesTheUserHaveOnlyCats() {
    return this.doesTheUserHaveCat && !this.doesTheUserHaveDog;
  }
}
